import { isElectron } from '@/utils/electron/electronUtils'
import { MODEL_TYPE_MAP } from '@/pages/Result/ModelDrift/const'

export const NODE_TYPES = {
  DATASET: 'dataset',
  LABELING: 'labeling',
  TRAIN: 'train',
  VALIDATION: 'validation',
  INFERENCE: 'inference',
  IMAGE_MATCHING: 'imageMatching',
  PREPROCESSING: 'preprocessing',
  PREPROCESSING_RESULT: 'preprocessingResult',
  ROI: 'roi',
  DATA_DRIFT: 'dataDrift',
  MODEL_DRIFT: 'modelDrift',
  MODEL_PERFORMANCE: 'modelPerformance',
  MODEL_RETRAIN: 'modelRetrain',
  MODEL_RETRAIN_EVALUATION: 'modelRetrainEvaluation',
  MODEL_PIPELINE_SOURCE: 'modelPipelineSource',
  MODEL_PIPELINE_INSTANCE: 'modelPipelineInstance',
  MODEL_PIPELINE_GATE: 'modelPipelineGate',
  MODEL_PIPELINE_MERGE: 'modelPipelineMerge',
  MODEL_PIPELINE_RESULT: 'modelPipelineResult',
  GROUP: 'group',
  DATA_STREAMING: 'dataStreaming',
  EDA: 'eda',
  EXTERNAL_MODEL: 'externalModel',
} as const

export type NodeTypeValueType = typeof NODE_TYPES[keyof typeof NODE_TYPES]

export const VALID_LINKS_BY_TYPE: { [key: string]: string[] } = !isElectron() ? {
  [NODE_TYPES.DATASET]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING],
  [NODE_TYPES.LABELING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION, NODE_TYPES.ROI],
  [NODE_TYPES.TRAIN]: [NODE_TYPES.VALIDATION, NODE_TYPES.INFERENCE],
  [NODE_TYPES.IMAGE_MATCHING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
  [NODE_TYPES.PREPROCESSING]: [NODE_TYPES.PREPROCESSING_RESULT],
  [NODE_TYPES.PREPROCESSING_RESULT]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING],
  [NODE_TYPES.EDA]: [NODE_TYPES.LABELING],
  [NODE_TYPES.ROI]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
  [NODE_TYPES.VALIDATION]: [NODE_TYPES.MODEL_PERFORMANCE],
  [NODE_TYPES.MODEL_PIPELINE_SOURCE]: [NODE_TYPES.GROUP],
  [NODE_TYPES.GROUP]: [NODE_TYPES.MODEL_PIPELINE_RESULT],
  [NODE_TYPES.EXTERNAL_MODEL]: [NODE_TYPES.INFERENCE],
  [NODE_TYPES.MODEL_PIPELINE_INSTANCE]: [NODE_TYPES.MODEL_PIPELINE_INSTANCE, NODE_TYPES.MODEL_PIPELINE_GATE, NODE_TYPES.MODEL_PIPELINE_MERGE],
  [NODE_TYPES.MODEL_PIPELINE_GATE]: [NODE_TYPES.MODEL_PIPELINE_INSTANCE, NODE_TYPES.MODEL_PIPELINE_GATE, NODE_TYPES.MODEL_PIPELINE_MERGE],
} : {
  [NODE_TYPES.DATASET]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING],
  [NODE_TYPES.LABELING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION, NODE_TYPES.ROI],
  [NODE_TYPES.TRAIN]: [NODE_TYPES.VALIDATION, NODE_TYPES.INFERENCE],
  [NODE_TYPES.IMAGE_MATCHING]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
  [NODE_TYPES.PREPROCESSING]: [NODE_TYPES.PREPROCESSING_RESULT],
  [NODE_TYPES.PREPROCESSING_RESULT]: [NODE_TYPES.LABELING, NODE_TYPES.INFERENCE, NODE_TYPES.IMAGE_MATCHING, NODE_TYPES.PREPROCESSING],
  [NODE_TYPES.EDA]: [NODE_TYPES.LABELING],
  [NODE_TYPES.ROI]: [NODE_TYPES.TRAIN, NODE_TYPES.VALIDATION],
}

export const OPS_VALID_LINKS_BY_TYPE: { [key: string]: string[] } = {
  [NODE_TYPES.DATASET]: [NODE_TYPES.LABELING, NODE_TYPES.MODEL_DRIFT],
  [NODE_TYPES.LABELING]: [NODE_TYPES.DATA_DRIFT],
  [NODE_TYPES.DATA_STREAMING]: [NODE_TYPES.DATA_DRIFT, NODE_TYPES.MODEL_DRIFT],
}
